module.exports = __webpack_public_path__ + "img/tip-bg.239d7848.png";